import { Paper, withStyles } from '@material-ui/core';
import React from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import config from "../../../config/config";

const styles = theme => ({
    root: {
        marginLeft: theme.spacing(-0.5),
        marginRight: theme.spacing(-0.5),
        marginTop: theme.spacing(-1),
        paddingTop: theme.spacing(1)
    }
});

// Single source of truth: fetch the spec the API serves (securaze-api/swagger.json via
// GET /api/api-docs.json) instead of bundling a local copy. Inject the logged-in session
// token so "Try it out" is authenticated — the gateway reads a Bearer token as `Token`.
const requestInterceptor = (req) => {
    const token = localStorage.getItem("SESSION");
    if (token) {
        req.headers = req.headers || {};
        req.headers["Authorization"] = `Bearer ${token}`;
    }
    return req;
};

const Documentation = props => {
    const { classes } = props;

    return (
        <Paper className={classes.root} >
            <SwaggerUI url={`${config.backend_url}/api/api-docs.json`} requestInterceptor={requestInterceptor} />
        </Paper>
    )
}

export default (withStyles(styles)(Documentation));
